// extracted by mini-css-extract-plugin
export default {"cls1":"vemLoZyp0Rx_vGqqIv29","cls2":"GR3HzEUCHOmiSVdd3Y4e vemLoZyp0Rx_vGqqIv29"};